import { Component,OnInit, ViewEncapsulation} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common'; 
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

@Component({
  selector: 'app-quantum-computing',
  imports: [
    CommonModule,
     FormsModule,
     RouterModule 
  ],
  templateUrl: './quantum-computing.component.html',
  styleUrl: './quantum-computing.component.scss',
   encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class QuantumComputingComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta,private canonicalService:CanonicalService) { }

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('Quantum Computing | AI & QPU Solutions by MALtech');

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content: 'Discover Maltech\'s cutting-edge quantum computing solutions, combining AI, QPU access, and advanced algorithms to solve complex problems faster and more efficiently.'
    });

    // Set meta keywords
    this.metaService.updateTag({
      name: 'keywords',
      content: 'Quantum Computing Solutions, Maltech, AI Integration, QPU Access, Advanced Algorithms, Quantum Technology'
    });

    // Optional: SEO enhancements
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });

    // Viewport meta tag for mobile optimization
    this.metaService.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1.0' });
    this.canonicalService.setCanonicalURL('service/quantum-computing/');
  }
  industries = [
    {
      title: 'Quantum Algorithms for Optimization',
      description:
        'Optimize complex systems and processes with quantum algorithms and solve highly complex optimization problems, in a fraction of the time compared to classical computing.',
    },
    {
      title: 'Quantum-Enhanced Machine Learning',
      description:
        'Accelerate AI and Data Science with quantum-powered models that process vast datasets, improve accuracy, and uncover hidden patterns for smarter, faster decision-making.',
    },
    {
      title: 'Quantum Cryptography & Security',
      description:
        'Enable next-generation cybersecurity with quantum key distribution and encryption methods that are virtually unbreakable, ensuring data security for enterprises.',
    },
    {
      title: 'Finance & Banking',
      description:
        'Revolutionize fraud detection, risk analysis, and investment strategies by applying quantum computing to financial modeling and real-time transaction monitoring.',
    },
    {
      title: 'Logistics & Transportation',
      description:
        'Optimize routes, fleet management, and traffic flow using quantum algorithms, reducing operational costs and improving efficiency in logistics and transportation systems.',
    },
    {
      title: 'Manufacturing',
      description:
        'Leverage quantum simulations to design advanced materials, streamline production processes, and enhance predictive maintenance for manufacturing excellence.',
    },
  ];

  steps = [
    {
      icon: 'bi-search',
      title: 'Assessment',
      description: 'Discover opportunities for cost reduction and speed improvements.'
    },
    {
      icon: 'bi-code-slash',
      title: 'Prototyping',
      description: 'Validate solutions before scaling.'
    },
    {
      icon: 'bi-cloud-check',
      title: 'Integration',
      description: 'Seamlessly embed into existing systems.'
    },
    {
      icon: 'bi-rocket-takeoff',
      title: 'Scaling',
      description: 'Support future growth with expert guidance.'
    }
  ];

  activeIndex = -1;

  setActive(index: number) {
    this.activeIndex = index;
  }

  clearActive() {
    this.activeIndex = -1;
  }

   features = [
    {
      icon: 'bi-globe2',
      title: 'Cutting-Edge Expertise',
      description: 'Our team of quantum experts possesses deep knowledge and experience in applying quantum computing to solve real-world business problems.'
    },
    {
      icon: 'bi-shield',
      title: 'Secure by Design',
      description: 'We integrate security into every aspect of our quantum solutions, ensuring the confidentiality, integrity, and availability of your data.'
    },
    {
      icon: 'bi-gear',
      title: 'Real-World Applications',
      description: 'We focus on delivering practical, impactful solutions that address your specific business needs and drive tangible results.'
    },
    {
      icon: 'bi-people',
      title: 'Trusted Partner',
      description: 'We are committed to building long-term partnerships with our clients, providing ongoing support and guidance throughout their quantum journey.'
    }
  ]; 
  
   faqs = [
    {
      question: 'Is Quantum Computing ready for real-world business use?',
      answer: 'Yes, while still evolving, Quantum Computing already provides breakthroughs in optimization, AI, and cybersecurity.'
    },
    {
      question: 'Do I need a quantum computer to get started?',
      answer: 'No. MALtech provides cloud-based access to quantum computing resources, so you don’t need your own hardware.'
    },
    {
      question: 'How does MALtech provide Quantum Computing solutions?',
      answer: 'We combine advanced quantum algorithms with domain expertise to deliver tailored business solutions that scale.'
    }
  ];

   getStart() {
    const plansSection = document.getElementById('get-start');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
  
}
